export const truncatedSentence = ({
  sentence,
  truncatedLength = 20,
}: {
  sentence: string;
  truncatedLength?: number;
}): string =>
  sentence?.length > truncatedLength ? sentence?.slice(0, truncatedLength).concat('...') : sentence;
